const styles = theme => ({
  topFiltersContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '16px',
    flexWrap: 'wrap',
    marginBottom: '32px',

    '& > :first-child': {
      flex: 1,
    },
  },

  topFiltersContainerMobile: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  title: {
    fontWeight: '600',
    fontSize: '21px',
    lineHeight: '32px',
    whiteSpace: 'nowrap',
  },
  filtersContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  searchFieldContainer: {
    minWidth: '300px',
    [theme.breakpoints.down('sm')]: {
      minWidth: 'auto',
      flex: 1,
    },
  },

  showModalBtn: {
    position: 'relative',
    background: theme.palette.primary.white,
    padding: '10px 30px',
    border: `1px solid ${theme.palette.primary.adgmBlack}`,
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  showModalBtnActive: {
    '&::before': {
      content: '""',
      width: '8px',
      height: '8px',
      position: 'absolute',
      top: '-3px',
      right: '-3px',
      background: theme.palette.primary.main,
      borderRadius: '50%',
      zIndex: '10',
    },
  },

  showModalBtnIcon: {
    marginRight: '8px',
  },

  showModalBtnText: {
    color: theme.palette.primary.adgmBlack,
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '21px',
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
  },
});

export default styles;
